module.exports = __webpack_public_path__ + "img/Slideshow BV EC 3.e0ca6e70.png";